import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function FormatsThickness({ idVariant = '', className }: Props) {
  return (
    <IconBase name="formats-thickness" w={38} h={26} className={className}>
      <path d="M0 0H16L8 8.5H38V18H1V8.5H8L0 0Z" fill="currentColor"/>
      <path d="M0 26L8 18.5L16 26H0Z" fill="currentColor"/>
    </IconBase>
  )
}

export default FormatsThickness
